// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VIOe","btnWrapper":"styles_btnWrapper__1ppfA","button":"styles_button__1JbJ3","subTitle":"styles_subTitle__3GJ9Q","text":"styles_text__igUDP"};